"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhoneNumber = void 0;
var min_1 = require("libphonenumber-js/min");
var validatePhoneNumber = function (value) {
    if (!value)
        return true;
    return (0, min_1.isValidPhoneNumber)('+' + value);
};
exports.validatePhoneNumber = validatePhoneNumber;
